/**
 * Google Viral APIs
 */

import $http from '@/libs/axios'

class ViralAPIs {
  static async info(branchId: number) {
    return (await $http.get(`/google/get-location/${branchId}`)).data.location
  }

  static async getStatus(branchId: number) {
    return (await $http.get(`/google/get-location-status/${branchId}`)).data.status
  }

  static async init(branchId: number, existed: 0 | 1) {
    return (await $http.post('/google/initiate-location', { branch_id: branchId, existed })).data
  }

  static async create(payload: any) {
    return (await $http.post('/google/create-location', payload)).data
  }

  static async update(payload: any) {
    return (await $http.post('/google/update-location', payload)).data
  }

  static async confirmStoreCode(branchId: number) {
    return (await $http.post('/google/confirm-existing-location', { branch_id: branchId })).data
  }

  static async verify(branchId: number, phone: string) {
    return (await $http.post('/google/verify-location', { branch_id: branchId, phone })).data
  }

  static async verifyPin(branchId: number, pinCode: string) {
    return (await $http.post('/google/complete-verification', { branch_id: branchId, pin_code: pinCode })).data
  }

  // 1 for top level 2 for direct parent level
  static async setMenuLevel(branchId: number, level: 1 | 2) {
    return (await $http.post('/google/set-menu-level ', { branch_id: branchId, menu_level: level })).data
  }

  static async reloadMenu(branchId: number) {
    return (await $http.post('/google/update-google-menu', { branch_id: branchId })).data
  }
}

export default ViralAPIs
